import { useState, useEffect } from 'react';
import { subscribeToShapes } from '../services/canvas';

/**
 * Custom hook for managing canvas shapes with Firestore integration
 * @returns {Object} { shapes: Array, loading: boolean }
 */
export function useCanvasShapes() {
  const [shapes, setShapes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    console.log('Setting up Firestore shapes subscription...');
    
    // Subscribe to real-time updates from Firestore
    const unsubscribe = subscribeToShapes((updatedShapes) => {
      console.log('Received shapes update from Firestore:', updatedShapes.length, 'shapes');
      setShapes(updatedShapes);
      setLoading(false);
    });

    // Cleanup subscription on unmount
    return () => {
      console.log('Cleaning up Firestore shapes subscription');
      unsubscribe();
    };
  }, []);

  return {
    shapes,
    loading
  };
}

export default useCanvasShapes;
